import React, { useState } from 'react';
import ProjectModal from './ProjectModal';
import { ProjectData } from '../../data/projects';
import ProjectCard from './ProjectCard'

const ProjectGrid = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <section className="mt-10 md:mt-20 px-4 md:px-8">
      <h2 className="text-2xl md:text-3xl text-center font-mono mb-8 md:mb-16">
        <span className="text-green-500">&lt;</span>
        <span className="text-[#ff00ff]">PROJECTS</span>
        <span className="text-green-500">/&gt;</span>
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
        {ProjectData.map((project) => (
          <ProjectCard 
            key={project.id}
            project={project} 
            onClick={() => setSelectedProject(project)}
          />
        ))}
      </div>
      {selectedProject && (
        <ProjectModal 
          project={selectedProject} 
          onClose={() => setSelectedProject(null)}
        />
      )}
    </section>
  );
};



export default ProjectGrid;